module.exports = __webpack_public_path__ + "static/media/sf-test-5.d3a67ea3.mp3";